export enum CohortIntensity {
  continuous = "continuous",
  bootcamp = "bootcamp",
  tracks = "tracks",
  apprenticeship = "apprenticeship",
  other = "other",
}
